import React from 'react';
import { useTranslation } from 'react-i18next';
import type { ClientBookingStatus } from '../../../types/client';

const STATUS_PALETTE = {
  PENDING:          { color: 'rgba(245,158,11,1)',   bg: 'rgba(245,158,11,0.10)'  },
  CONFIRMED:        { color: 'rgba(51,144,236,1)',   bg: 'rgba(51,144,236,0.10)'  },
  CANCELLED:        { color: 'rgba(239,68,68,1)',    bg: 'rgba(239,68,68,0.10)'   },
  COMPLETED:        { color: 'rgba(31,139,76,1)',    bg: 'rgba(31,139,76,0.10)'   },
  EXPIRED:          { color: 'rgba(100,116,139,1)',  bg: 'rgba(100,116,139,0.10)' },
  REFUND_REQUESTED: { color: 'rgba(139,92,246,1)',   bg: 'rgba(139,92,246,0.10)'  },
  REFUND_COMPLETED: { color: 'rgba(31,139,76,1)',    bg: 'rgba(31,139,76,0.10)'   },
  REJECTED:         { color: 'rgba(100,116,139,1)',  bg: 'rgba(100,116,139,0.10)' },
} satisfies Record<ClientBookingStatus, { color: string; bg: string }>;

interface Props {
  status: ClientBookingStatus;
}

export const ClientStatusBadge: React.FC<Props> = ({ status }) => {
  const { t } = useTranslation('customer');
  const cfg = STATUS_PALETTE[status] ?? STATUS_PALETTE['PENDING'];
  const label = t(`bookings.statusLabels.${status}`, {
    defaultValue: status,
  });
  return (
    <span style={{
      display: 'inline-block',
      fontSize: 11,
      fontWeight: 600,
      color: cfg.color,
      background: cfg.bg,
      borderRadius: 20,
      padding: '3px 10px',
      lineHeight: '1.5',
      flexShrink: 0,
      whiteSpace: 'nowrap',
    }}>
      {label}
    </span>
  );
};

export { STATUS_PALETTE };
